<template>
  <div class="interface-config">
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="interface-config-main">
      <div class="interface-config-main-left">
        <p style="margin: 25px 0;text-align: center;color: #999999;" v-if="!modifyModuleName">请先点击修改按钮</p>
        <draggable element="div" :list="allModuleList" group="allModule" class="screen-top-list" v-if="modifyModuleName==='allModule'">
          <div v-for="item in allModuleList" class="main-screen-top-item" :key="item.name" >
            <span>{{item.name}}</span>
          </div>
        </draggable>

        <draggable element="div" :list="modifyModuleLeftList" :group="modifyModuleName" class="screen-top-list" v-if="modifyModuleName && modifyModuleName!=='allModule'">
          <div v-for="item in modifyModuleLeftList" class="main-screen-top-item" :key="item.name" >
            <span>{{item.showName}}</span>
          </div>
        </draggable>
        <button-confirm @confirm="saveAndReturn" value="保存并返回修改布局" style="margin: 20px auto" v-if="modifyModuleName && modifyModuleName!=='allModule'" />
      </div>
      <div class="page-right">
        <div class="screen-config-main-top">
          <div class="screen-config-main-top-tip">
            <i class="el-icon-damai-tishi" style="color: #00a0e6;margin-right: 5px"></i>
            <span>点击右侧修改按钮可配置整体布局，双击具体模块可配置模块内部数据</span>
          </div>
          <button-cancel @cancel="modifyConfig" v-if="!modifyModuleName" value="修改" />
          <button-confirm @confirm="saveConfig" value="保存" v-else />
        </div>

        <div class="interface-config-main-right">
          <div class="main-screen-title" @dblclick="changeDetailConfig([], '标题')">{{yqDashboardTitle}}</div>
          <!--<div class="main-screen-top-div">-->
          <!--<draggable element="div" :list="mainScreenTopChooseList" class="main-screen-top" group="screenTop" >-->
          <!--<div v-for="item in mainScreenTopChooseList" class="main-screen-top-item" :key="item.name" >-->
          <!--<span>{{item.name}}</span>-->
          <!--</div>-->
          <!--</draggable>-->
          <!--<i class="el-icon-edit" @click="changeScreenTop"></i>-->
          <!--</div>-->
          <div class="main-screen-main">
            <!--左-->
            <draggable element="div" :list="chooseLeftList" group="allModule" :disabled="modifyModuleName!=='allModule'" class="main-screen-main-left" :class="{'has-box-shadow': modifyModuleName==='allModule' }">
              <div v-for="item in chooseLeftList" :key="item.name" :class="'screen-height-'+item.size" @dblclick="changeDetailConfig(chooseLeftList, item)" :style="{boxShadow: modifyModuleName===item.name?'0 0 15px #00A0E6': '0' }">
                <div class="box-title" v-if="item.name !== '园区展示图'">{{item.name}}</div>
                <img :src="yqDashboardPic" v-if="item.name === '园区展示图' && yqDashboardPic" style="width: 100%;height: 100%;border-radius: 10px;position: absolute;top: 0;left: 0;opacity: 0.8;" alt="">
                <img src="../../../assets/interface/noPic.png" v-if="item.name === '园区展示图' && !yqDashboardPic" style="width: 100%;height: 100%;border-radius: 10px;position: absolute;top: 0;left: 0;opacity: 0.8;" alt="">

                <!--子内容-->
                <draggable element="div" :list="item.child" :group="item.name" :disabled="modifyModuleName!==item.name" :class="item.size === '1' ? 'info-main-child-1' : 'info-main-child-2'" v-if="item.name !== '基础展示'">
                  <div v-for="child in item.child" :id="child.idName" :style="{width: child.width,height: child.height}">
                    <div v-if="child.name" class="box-title">{{child.name}}</div>
                    <div  :class="child.idName" ></div>
                  </div>
                </draggable>

                <div :class="item.size === '1' ? 'info-main-child-1' : 'info-main-child-2'" v-else>
                  <div v-for="child in item.child" :id="child.idName" :style="{width: child.width,height: child.height}">
                    <div v-if="child.name" class="box-title">{{child.name}}</div>
                    <draggable element="div" :list="child.ringData" :group="item.name" :disabled="modifyModuleName!==item.name" class="basic-info" >
                      <div v-for="ring in child.ringData" :key="ring.name" :class="ring.eName"></div>
                    </draggable>
                  </div>
                </div>
              </div>
            </draggable>

            <!--中-->
            <draggable element="div" :list="chooseMiddleList" group="allModule" :disabled="modifyModuleName!=='allModule'" class="main-screen-main-middle" :class="{'has-box-shadow': modifyModuleName==='allModule' }">
              <div v-for="item in chooseMiddleList" :key="item.name" :class="'screen-height-'+item.size" @dblclick="changeDetailConfig(chooseLeftList, item)" :style="{boxShadow: modifyModuleName===item.name?'0 0 15px #00A0E6': '0'}">
                <div class="box-title" v-if="item.name !== '园区展示图'">{{item.name}}</div>
                <img :src="yqDashboardPic" v-if="item.name === '园区展示图' && yqDashboardPic" style="width: 100%;height: 100%;border-radius: 10px;position: absolute;top: 0;left: 0;opacity: 0.8;" alt="">
                <img src="../../../assets/interface/noPic.png" v-if="item.name === '园区展示图' && !yqDashboardPic" style="width: 100%;height: 100%;border-radius: 10px;position: absolute;top: 0;left: 0;opacity: 0.8;" alt="">
                <!--子内容-->
                <draggable element="div" :list="item.child" :group="item.name" :disabled="modifyModuleName!==item.name" :class="item.size === '1' ? 'info-main-child-1' : 'info-main-child-2'" v-if="item.name !== '基础展示'">
                  <div v-for="child in item.child" :id="child.idName" :style="{width: child.width,height: child.height}">
                    <div v-if="child.name" class="box-title">{{child.name}}</div>
                    <div  :class="child.idName" ></div>
                  </div>
                </draggable>

                <div :class="item.size === '1' ? 'info-main-child-1' : 'info-main-child-2'" v-else>
                  <div v-for="child in item.child" :id="child.idName" :style="{width: child.width,height: child.height}">
                    <div v-if="child.name" class="box-title">{{child.name}}</div>
                    <draggable element="div" :list="child.ringData" :group="item.name" :disabled="modifyModuleName!==item.name" class="basic-info" >
                      <div v-for="ring in child.ringData" :key="ring.name" :class="ring.eName"></div>
                    </draggable>
                  </div>
                </div>
              </div>
            </draggable>

            <!--右-->
            <draggable element="div" :list="chooseRightList" group="allModule" :disabled="modifyModuleName!=='allModule'" class="main-screen-main-right" :class="{'has-box-shadow': modifyModuleName==='allModule' }">
              <div v-for="item in chooseRightList" :key="item.name" :class="'screen-height-'+item.size" @dblclick="changeDetailConfig(chooseRightList, item)" :style="{boxShadow: modifyModuleName===item.name?'0 0 15px #00A0E6': '0'}">
                <div class="box-title" v-if="item.name !== '园区展示图'">{{item.name}}</div>
                <img :src="yqDashboardPic" v-if="item.name === '园区展示图' && yqDashboardPic" style="width: 100%;height: 100%;border-radius: 10px;position: absolute;top: 0;left: 0;opacity: 0.8;" alt="">
                <img src="../../../assets/interface/noPic.png" v-if="item.name === '园区展示图' && !yqDashboardPic" style="width: 100%;height: 100%;border-radius: 10px;position: absolute;top: 0;left: 0;opacity: 0.8;" alt="">
                <!--子内容-->
                <draggable element="div" :list="item.child" :group="item.name" :disabled="modifyModuleName!==item.name" :class="item.size === '1' ? 'info-main-child-1' : 'info-main-child-2'" v-if="item.name !== '基础展示'">
                  <div v-for="child in item.child" :id="child.idName" :style="{width: child.width,height: child.height}">
                    <div v-if="child.name" class="box-title">{{child.name}}</div>
                    <div  :class="child.idName" ></div>
                  </div>
                </draggable>

                <div :class="item.size === '1' ? 'info-main-child-1' : 'info-main-child-2'" v-else>
                  <div v-for="child in item.child" :id="child.idName" :style="{width: child.width,height: child.height}">
                    <div v-if="child.name" class="box-title">{{child.name}}</div>
                    <draggable element="div" :list="child.ringData" :group="item.name" :disabled="modifyModuleName!==item.name" class="basic-info" >
                      <div v-for="ring in child.ringData" :key="ring.name" :class="ring.eName"></div>
                    </draggable>
                  </div>
                </div>
              </div>
            </draggable>
          </div>
        </div>

        <button-cancel @cancel="toDataPage" v-if="!modifyModuleName" value="预览" style="width: 160px;margin: 30px auto 0" />
      </div>

    </div>


    <el-dialog
      title="修改园区展示图"
      :visible.sync="imgDialogVisible"
      width="40%">
      <input id="uploadGuidedGraph" name="file" accept="image/*" type="file"
             @change="upData2" style="display: none" />
      <div style="margin: 20px 0;">
        <a class="newly2" @click="upImg2" v-if="!yqDashboardPicChange">
          <span><i class="el-icon-plus"></i></span>
          <span>点击上传</span>
        </a>
        <a class="upload2" @click="upImg2" v-if="yqDashboardPicChange">
          <img :src="yqDashboardPicChange" id="packBg" />
          <b>重新上传</b>
        </a>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="cancelChangePic">取 消</el-button>
        <el-button size="mini" type="primary" @click="confirmChangePic">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="修改标题"
      :visible.sync="titleDialogVisible"
      width="40%">
      <div style="margin: 40px 0;">
        <el-input v-model="modifyYqDashboardTitle" style="width: 280px;margin: 0 auto;" />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="cancelChangeTitle">取 消</el-button>
        <el-button size="mini" type="primary" @click="confirmChangeTitle">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
  import draggable from 'vuedraggable'
  import {api} from '../../api/InterfaceConfig'
  import {errorHandler} from '../../../utils/errorHandler'
  import ButtonCancel from '../../../components/Button/ButtonCancel'
  import ButtonConfirm from '../../../components/Button/ButtonConfirm'
  import {nError} from '../../../utils/notice'
  import {bus} from '../../../utils/bus'

  export default {
    components: {
      ButtonConfirm,
      ButtonCancel,
      Breadcrumb,
      draggable,
    },
    name: 'interface-config',
    data () {
      return {
        breadcrumb: [{
          value: '智慧大脑',
          name: 'interface-config'
        }, {
          value: '屏幕配置'
        }],

        defaultModuleList: [
          {
            name: '门禁总览',
            size: '1',
            idName: '',
            child: [
              {
                name: '',
                showName: '门禁设备',
                width: '34%',
                height: '100%',
                size: '1',
                idName: 'accessMeter',
                component: 'commonRing',
                xAxis: {},
                yAxis: [],
                series: [],
                ringData: [],
              },
              {
                name: '',
                showName: '进出记录',
                width: '66%',
                height: '100%',
                size: '1',
                idName: 'accessLine',
                component: 'commonLine',
                xAxis: [],
                yAxis: [],
                series: [],
                ringData: [],
              }
            ]
          },
          {
            name: '基础展示',
            size: '1',
            idName: '',
            child: [
              {
                name: '',
                width: '100%',
                height: '100%',
                size: '1',
                idName: 'basicInfo',
                component: 'basicInfo',
                xAxis: {},
                yAxis: [],
                series: [],
                ringData: [
                  { name: '管理面积', showName: '管理面积', eName: 'area', value: '0', unit: 'm²', width: '50%'},
                  { name: '房源总数', showName: '房源总数', eName: 'fy', value: '0', unit: '间', width: '50%'},
                  { name: '招商房源', showName: '招商房源', eName: 'zsfy', value: '0', unit: '间', width: '50%'},
                  { name: '房源出租率', showName: '房源出租率', eName: 'czl', value: '0', unit: '', width: '50%'},
                  { name: '入驻企业', showName: '入驻企业', eName: 'qy', value: '0', unit: '家', width: '50%'},
                  { name: '园区人员', showName: '园区人员', eName: 'ry', value: '0', unit: '人', width: '50%'},
                ],
              }
            ]
          },
          {
            name: '预约总览',
            size: '2',
            idName: '',
            child: [
              {
                name: '',
                showName: '预约次数',
                width: '100%',
                height: '50%',
                size: '1',
                idName: 'appointmentBar',
                component: 'commonStackingBar',
                xAxis: {},
                yAxis: [],
                series: [],
                ringData: [],
              },
              {
                name: '',
                showName: '预约费',
                width: '100%',
                height: '50%',
                size: '1',
                idName: 'appointmentLine',
                component: 'commonLine',
                xAxis: {},
                yAxis: [],
                series: [],
                ringData: [],
              }
            ]
          },
          {
            name: '园区展示图',
            size: '1',
            noBg: true,
            idName: '',
            child: [
              {
                name: '',
                width: '100%',
                height: '100%',
                size: '1',
                idName: 'yqImg',
                component: 'yqImg',
                xAxis: {},
                yAxis: [],
                series: [],
                ringData: [],
              }
            ]
          },
          {
            name: '园区动态',
            size: '2',
            idName: '',
            child: [
              {
                name: '',
                showName: '当日园区流量',
                width: '100%',
                height: '40%',
                size: '1',
                idName: 'flowNumber',
                component: 'flowNumber',
                xAxis: {},
                yAxis: [],
                series: [],
                ringData: [],
              },
              {
                name: '',
                showName: '7日园区流量',
                width: '100%',
                height: '60%',
                size: '1',
                idName: 'recordLine',
                component: 'commonLine',
                xAxis: {},
                yAxis: [],
                series: [],
                ringData: [],
              }
            ]
          },
          {
            name: '电控总览',
            size: '1',
            idName: '',
            child: [
              {
                name: '',
                showName: '电控设备',
                width: '34%',
                height: '100%',
                size: '1',
                idName: 'electronicMeter',
                component: 'commonRing',
                xAxis: {},
                yAxis: [],
                series: [],
                ringData: [],
              },
              {
                name: '',
                showName: '7日用电量',
                width: '66%',
                height: '100%',
                size: '1',
                idName: 'electronicLine',
                component: 'commonLine',
                xAxis: {},
                yAxis: [],
                series: [],
                ringData: [],
              }
            ]
          },
          {
            name: '报修总览',
            size: '2',
            idName: '',
            child: [
              {
                name: '',
                showName: '报修次数',
                width: '100%',
                height: '50%',
                size: '1',
                idName: 'repairBar',
                component: 'commonStackingBar',
                xAxis: {},
                yAxis: [],
                series: [],
                ringData: [],
              },
              {
                name: '',
                showName: '报修费',
                width: '100%',
                height: '50%',
                size: '1',
                idName: 'repairLine',
                component: 'commonLine',
                xAxis: {},
                yAxis: [],
                series: [],
                ringData: [],
              }
            ]
          }
        ],

        allModuleList: [
          {
            name: '门禁总览',
            size: '1',
            idName: '',
            child: [
              {
                name: '',
                showName: '门禁设备',
                width: '34%',
                height: '100%',
                size: '1',
                idName: 'accessMeter',
                component: 'commonRing',
                xAxis: {},
                yAxis: [],
                series: [],
                ringData: [],
              },
              {
                name: '',
                showName: '进出记录',
                width: '66%',
                height: '100%',
                size: '1',
                idName: 'accessLine',
                component: 'commonLine',
                xAxis: [],
                yAxis: [],
                series: [],
                ringData: [],
              }
            ]
          },
          {
            name: '基础展示',
            size: '1',
            idName: '',
            child: [
              {
                name: '',
                width: '100%',
                height: '100%',
                size: '1',
                idName: 'basicInfo',
                component: 'basicInfo',
                xAxis: {},
                yAxis: [],
                series: [],
                ringData: [
                  { name: '管理面积', showName: '管理面积', eName: 'area', value: '0', unit: 'm²', width: '50%'},
                  { name: '房源总数', showName: '房源总数', eName: 'fy', value: '0', unit: '间', width: '50%'},
                  { name: '招商房源', showName: '招商房源', eName: 'zsfy', value: '0', unit: '间', width: '50%'},
                  { name: '房源出租率', showName: '房源出租率', eName: 'czl', value: '0', unit: '', width: '50%'},
                  { name: '入驻企业', showName: '入驻企业', eName: 'qy', value: '0', unit: '家', width: '50%'},
                  { name: '园区人员', showName: '园区人员', eName: 'ry', value: '0', unit: '人', width: '50%'},
                ],
              }
            ]
          },
          {
            name: '预约总览',
            size: '2',
            idName: '',
            child: [
              {
                name: '',
                showName: '预约次数',
                width: '100%',
                height: '50%',
                size: '1',
                idName: 'appointmentBar',
                component: 'commonStackingBar',
                xAxis: {},
                yAxis: [],
                series: [],
                ringData: [],
              },
              {
                name: '',
                showName: '预约费',
                width: '100%',
                height: '50%',
                size: '1',
                idName: 'appointmentLine',
                component: 'commonLine',
                xAxis: {},
                yAxis: [],
                series: [],
                ringData: [],
              }
            ]
          },
          {
            name: '园区展示图',
            size: '1',
            noBg: true,
            idName: '',
            child: [
              {
                name: '',
                width: '100%',
                height: '100%',
                size: '1',
                idName: 'yqImg',
                component: 'yqImg',
                xAxis: {},
                yAxis: [],
                series: [],
                ringData: [],
              }
            ]
          },
          {
            name: '园区动态',
            size: '2',
            idName: '',
            child: [
              {
                name: '',
                showName: '当日园区流量',
                width: '100%',
                height: '40%',
                size: '1',
                idName: 'flowNumber',
                component: 'flowNumber',
                xAxis: {},
                yAxis: [],
                series: [],
                ringData: [],
              },
              {
                name: '',
                showName: '7日园区流量',
                width: '100%',
                height: '60%',
                size: '1',
                idName: 'recordLine',
                component: 'commonLine',
                xAxis: {},
                yAxis: [],
                series: [],
                ringData: [],
              }
            ]
          },
          {
            name: '电控总览',
            size: '1',
            idName: '',
            child: [
              {
                name: '',
                showName: '电控设备',
                width: '34%',
                height: '100%',
                size: '1',
                idName: 'electronicMeter',
                component: 'commonRing',
                xAxis: {},
                yAxis: [],
                series: [],
                ringData: [],
              },
              {
                name: '',
                showName: '7日用电量',
                width: '66%',
                height: '100%',
                size: '1',
                idName: 'electronicLine',
                component: 'commonLine',
                xAxis: {},
                yAxis: [],
                series: [],
                ringData: [],
              }
            ]
          },
          {
            name: '报修总览',
            size: '2',
            idName: '',
            child: [
              {
                name: '',
                showName: '报修次数',
                width: '100%',
                height: '50%',
                size: '1',
                idName: 'repairBar',
                component: 'commonStackingBar',
                xAxis: {},
                yAxis: [],
                series: [],
                ringData: [],
              },
              {
                name: '',
                showName: '报修费',
                width: '100%',
                height: '50%',
                size: '1',
                idName: 'repairLine',
                component: 'commonLine',
                xAxis: {},
                yAxis: [],
                series: [],
                ringData: [],
              }
            ]
          },
          {
            name: '访客总览',
            size: '1',
            idName: '',
            child: [
              {
                name: '',
                width: '100%',
                height: '100%',
                size: '1',
                idName: 'visitorLine',
                component: 'commonLine',
                xAxis: {},
                yAxis: [],
                series: [],
                ringData: [],
              }
            ]
          }
        ],


        chooseLeftList: [],
        chooseMiddleList: [],
        chooseRightList: [],


        modifyModuleName: '',
        modifyModuleLeftList: [],

        imgDialogVisible: false,
        titleDialogVisible: false,
        pictureBase64: '',
        yqDashboardTitle: '',
        modifyYqDashboardTitle: '',
        yqDashboardPic: '',
        yqDashboardPicChange: ''
      }
    },

    created () {
      this.getConfig()
    },

    methods: {
      changeScreenTop () {
        this.currentArea = 'screenTop'
      },

      // 保存并返回整体修改
      saveAndReturn () {
        this.modifyModuleName = 'allModule'
      },

      // 修改整体
      modifyConfig () {
        this.modifyModuleName = 'allModule'
      },

      // 修改具体模块
      changeDetailConfig (list, item) {
        if (this.modifyModuleName === '') {
          nError('请先点击修改')
          return
        }
        if (item === '标题') {
          this.titleDialogVisible = true
        } else if (item.name === '基础展示') {
          let childChoose = []
          let modifyModuleLeftList = []
          item.child.map(itemChild => {
            itemChild.ringData.map(ring => {
              childChoose.push(ring.showName)
            })
          })
          this.modifyModuleName = item.name
          this.defaultModuleList.map(allModule => {
            if (allModule.name === item.name) {
              allModule.child.map(childItem => {
                childItem.ringData.map(ringItem => {
                  if (childChoose.indexOf(ringItem.showName) === -1) {
                    modifyModuleLeftList.push(ringItem)
                  }
                })
              })
            }
          })
          this.modifyModuleLeftList = modifyModuleLeftList
        } else if (item.name === '园区展示图') {
          // 修改图片
          this.imgDialogVisible = true
        } else {
          let childChoose = []
          let modifyModuleLeftList = []
          item.child.map(itemChild => {
            childChoose.push(itemChild.idName)
          })
          this.modifyModuleName = item.name
          this.defaultModuleList.map(allModule => {
            if (allModule.name === item.name) {
              allModule.child.map(childItem => {
                if (childChoose.indexOf(childItem.idName) === -1) {
                  modifyModuleLeftList.push(childItem)
                }
              })
            }
          })
          this.modifyModuleLeftList = modifyModuleLeftList
        }

      },

      // 获取配置
      getConfig () {
        this.$axios.post(`${api.getConfig}`, {})
          .then(res => {
            if (res.data.retCode === 1) {
              let data = res.data.data
              let hasModule = []
              let allModuleList = []
              if (data.yqDashboardConfig) {
                this.chooseLeftList = data.yqDashboardConfig.leftConfig || []
                this.chooseMiddleList = data.yqDashboardConfig.middleConfig || []
                this.chooseRightList = data.yqDashboardConfig.rightConfig || []
                this.chooseLeftList.map(left => {
                  hasModule.push(left.name)
                })
                this.chooseMiddleList.map(middle => {
                  hasModule.push(middle.name)
                })
                this.chooseRightList.map(right => {
                  hasModule.push(right.name)
                })
              }
              if (data.yqDashboardTitle) {
                this.yqDashboardTitle = data.yqDashboardTitle
              } else {
                this.yqDashboardTitle = data.yqName
              }
              this.modifyYqDashboardTitle = this.yqDashboardTitle
              this.yqDashboardPic = data.yqDashboardPic

              this.defaultModuleList.map(module => {
                if (hasModule.indexOf(module.name) === -1) {
                  allModuleList.push(module)
                }
              })

              this.allModuleList = allModuleList
            }
          })
          .catch(errorHandler('获取失败'))
      },

      // 保存配置
      saveConfig () {
        this.$axios.post(`${api.saveConfig}`, {
          yqDashboardTitle: this.yqDashboardTitle,
          yqDashboardPic: this.yqDashboardPic,
          yqDashboardConfig: {
            leftConfig: this.chooseLeftList,
            middleConfig: this.chooseMiddleList,
            rightConfig: this.chooseRightList
          }
        })
          .then(res => {
            if (res.data.retCode === 1) {
              this.modifyModuleName = ''
              this.getConfig()
              this.modifyYqDashboardTitle = false
            }
          })
          .catch(errorHandler('保存失败'))
      },

      // 上传图片
      upData2: function () {
        let that = this
        const oFReader = new FileReader()
        const file = document.getElementById('uploadGuidedGraph').files[0]
        // if (file.size > 1024 * 1024) {
        //   nError('上传图片不能大于1M')
        //   return false
        // }
        oFReader.readAsDataURL(file)
        oFReader.onloadend = function (oFRevent) {
          const src = oFRevent.target.result
          that.pictureBase64 = src
          that.uploadPicture()
        }
      },
      upImg2: function () {
        document.getElementById('#uploadBackgroundImg')
        $('#uploadGuidedGraph')
          .click() // 隐藏了input:file样式后，点击头像就可以本地上传
          .on('change', function () {
            // const objUrl = getObjectURL(this.files[0])
            // if (objUrl) {
            //   $('#pic2').attr('src', objUrl)
            // }
          })
      },

      // 上传图片
      uploadPicture () {
        const loading = this.$loading({
          lock: true,
          text: '请稍后',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        this.$axios.post(api.uploadImg, {
          picData: this.pictureBase64
        })
          .then(res => {
            loading.close()
            if (res.data.retCode === 1) {
              this.yqDashboardPicChange = res.data.data
            } else {
              // 提示信息，需引入Message
              nError('图片上传失败')
            }
          })
          .catch(errorHandler('图片上传失败'))
          .then(() => {
            loading.close()
          })
      },

      // 确认修改图片
      confirmChangePic () {
        if (!this.yqDashboardPicChange) {
          nError('请先选择图片')
        } else {
          this.yqDashboardPic = this.yqDashboardPicChange
          this.yqDashboardPicChange = ''
          this.imgDialogVisible = false
        }
      },

      // 取消修改图片
      cancelChangePic () {
        this.yqDashboardPicChange = ''
        this.imgDialogVisible = false
      },

      confirmChangeTitle () {
        this.yqDashboardTitle = this.modifyYqDashboardTitle
        this.titleDialogVisible = false
      },

      // 取消修改标题
      cancelChangeTitle () {
        this.modifyYqDashboardTitle = this.yqDashboardTitle
        this.titleDialogVisible = false
      },

      // 预览
      toDataPage () {
        window.open(`http://yq.damaiiot.com/dataPage.html#/login_without/${bus.global.yqCode}/${bus.global.accountCode}`, '_blank')
      }
    }
  }
</script>

<style lang="less">
  .interface-config {
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    .interface-config-main {
      flex: 1;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .interface-config-main-left {
        width: 200px;
        height: 100%;
        border-right: 1px solid #eeeeee;
        .screen-top-list {
          width: 200px;
          padding: 20px;
          min-height: 200px;
          height: auto;
          .main-screen-top-item {
            cursor: pointer;
            line-height: 60px;
            color: #ffffff;
            background: #75bfe6;
            margin-bottom: 10px;
            border-radius: 10px;
            border-bottom: 1px solid #ffffff;
          }
        }
      }

      .basic-info {
        width: 100%;
        height: 100%;
        padding: 0 0.2rem;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        .basic-info-item {
          width: 33%;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          text-align: left;

        }

        .area {
          width: 33%;
          height: 50%;
          background: url("../../../assets/interface/area.png") no-repeat center;
          background-size: 100% auto;
        }
        .fy {
          width: 33%;
          height: 50%;
          background: url("../../../assets/interface/fy.png") no-repeat center;
          background-size: 100% auto;
        }
        .zsfy {
          width: 33%;
          height: 50%;
          background: url("../../../assets/interface/zsfy.png") no-repeat center;
          background-size: 100% auto;
        }
        .czl {
          width: 33%;
          height: 50%;
          background: url("../../../assets/interface/czl.png") no-repeat center;
          background-size: 100% auto;
        }
        .qy {
          width: 33%;
          height: 50%;
          background: url("../../../assets/interface/qy.png") no-repeat center;
          background-size: 100% auto;
        }
        .ry {
          width: 33%;
          height: 50%;
          background: url("../../../assets/interface/ry.png") no-repeat center;
          background-size: 100% auto;
        }
      }


      .page-right {
        height: 100%;
        display: flex;
        justify-content: flex-start;
        flex-direction: column;
        .screen-config-main-top {
          width: 1000px;
          margin: 20px 0 30px 50px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .screen-config-main-top-tip {
            color: #666666;
            display: flex;
            justify-content: flex-start;
            align-items: center;
          }
        }
        /*右侧主屏*/
        .interface-config-main-right {
          color: #ffffff;
          width: 1000px;
          height: 562.5px;
          border: 1px solid #eeeeee;
          margin-left: 50px;
          background: url("../../../assets/interface_bg.png") no-repeat;
          background-size: 100% 100%;
          .main-screen-title {
            font-size: 20px;
            line-height: 30px;
            font-weight: 500;
            color: #ffffff;
          }
          .main-screen-top-div {
            position: relative;
            border: 1px solid #eeeeee;
            width: 900px;
            height: 80px;
            padding: 0 10px;
            line-height: 60px;
            margin: 0 auto;
            .main-screen-top {
              display: flex;
              justify-content: space-between;
              align-items: center;
              .main-screen-top-item {
                cursor: pointer;
                color: #ffffff;
                background: #75bfe6;
                padding: 0 10px;
              }
            }

            .el-icon-edit {
              font-size: 18px;
              position: absolute;
              right: -20px;
              top: 0;
              display: none;
            }
          }

          .main-screen-top-div:hover {
            .el-icon-edit {
              display: block;
            }
          }

          .main-screen-main {
            width: 960px;
            margin: 30px auto 0;
            display: flex;
            justify-content: space-between;

            .has-box-shadow {
              box-shadow: 0 0 15px #00a0e6;
            }
            .screen-height-1 {
              width: 300px;
              height: 180px;
              padding: 6px;
              background: url("../../../assets/top_frame.png") no-repeat;
              background-size: 100% 100%;
              display: flex;
              justify-content: flex-start;
              flex-direction: column;
              position: relative;
            }

            .screen-height-2 {
              width: 300px;
              height: 260px;
              padding: 6px;
              background: url("../../../assets/bottom_frame.png") no-repeat;
              background-size: 100% 100%;
              display: flex;
              justify-content: flex-start;
              flex-direction: column;
            }

            .main-screen-main-left {
              width: 300px;
              height: 460px;
              /*border: 1px solid #eeeeee;*/
              display: flex;
              justify-content: space-between;
              flex-direction: column;
            }
            .main-screen-main-middle {
              width: 320px;
              height: 460px;
              /*border: 1px solid #eeeeee;*/
              display: flex;
              justify-content: space-between;
              flex-direction: column;
              .screen-height-1 {
                width: 320px;
                height: 180px;
                background: url("../../../assets/top_frame.png") no-repeat;
                background-size: 100% 100%;
              }
              .screen-height-2 {
                width: 320px;
                height: 260px;
                background: url("../../../assets/bottom_frame.png") no-repeat;
                background-size: 100% 100%;
              }
            }
            .main-screen-main-right {
              width: 300px;
              height: 460px;
              /*border: 1px solid #eeeeee;*/
              display: flex;
              justify-content: space-between;
              flex-direction: column;
            }


            .box-title {
              color: #ffffff;
              font-size: 12px;
              line-height: 30px;
            }

            .info-main-child-1 {
              display: flex;
              justify-content: space-between;
              flex: 1;
            }

            .info-main-child-2 {
              display: flex;
              justify-content: space-between;
              flex-direction: column;
              flex: 1;
            }

            .info-main-child-1>div {
              margin: 0 auto;
            }

            .info-main-child-2>div>div {
              flex: 1;
            }

            #accessMeter {
              display: flex;
              justify-content: flex-start;
              flex-direction: column;
              .accessMeter {
                flex: 1;
                width: 100%;
                height: 100%;
                background: url("../../../assets/interface/accessMeter.jpg") no-repeat center;
                background-size: auto 100%;
              }
            }

            #accessLine {
              display: flex;
              justify-content: flex-start;
              flex-direction: column;
              .accessLine {
                flex: 1;
                width: 100%;
                height: 100%;
                background: url("../../../assets/interface/accessLine.png") no-repeat center;
                background-size: 100% auto;
              }
            }

            #appointmentBar {
              display: flex;
              justify-content: flex-start;
              flex-direction: column;
              .appointmentBar {
                flex: 1;
                width: 100%;
                height: 100%;
                background: url("../../../assets/interface/appointmentBar.png") no-repeat center;
                background-size: auto 100%;
              }
            }
            #appointmentLine {
              display: flex;
              justify-content: flex-start;
              flex-direction: column;
              .appointmentLine {
                flex: 1;
                width: 100%;
                height: 100%;
                background: url("../../../assets/interface/appointmentLine.jpg") no-repeat center;
                background-size: auto 100%;
              }
            }
            #flowNumber {
              display: flex;
              justify-content: flex-start;
              flex-direction: column;
              .flowNumber {
                flex: 1;
                width: 100%;
                height: 100%;
                background: url("../../../assets/interface/flowNumber.png") no-repeat center;
                background-size: auto 100%;
              }
            }
            #recordLine {
              display: flex;
              justify-content: flex-start;
              flex-direction: column;
              .recordLine {
                flex: 1;
                width: 100%;
                height: 100%;
                background: url("../../../assets/interface/recordLine.jpg") no-repeat center;
                background-size: 100% auto;
              }
            }
            #repairBar {
              display: flex;
              justify-content: flex-start;
              flex-direction: column;
              .repairBar {
                flex: 1;
                width: 100%;
                height: 100%;
                background: url("../../../assets/interface/repairBar.jpg") no-repeat center;
                background-size: auto 100%;
              }
            }
            #repairLine {
              display: flex;
              justify-content: flex-start;
              flex-direction: column;
              .repairLine {
                flex: 1;
                width: 100%;
                height: 100%;
                background: url("../../../assets/interface/repairLine.jpg") no-repeat center;
                background-size: auto 100%;
              }
            }
            #electronicMeter {
              display: flex;
              justify-content: flex-start;
              flex-direction: column;
              .electronicMeter {
                flex: 1;
                width: 100%;
                height: 100%;
                background: url("../../../assets/interface/electronicMeter.jpg") no-repeat center;
                background-size: auto 100%;
              }
            }
            #electronicLine {
              display: flex;
              justify-content: flex-start;
              flex-direction: column;
              .electronicLine {
                flex: 1;
                width: 100%;
                height: 100%;
                background: url("../../../assets/interface/electronicLine.jpg") no-repeat center;
                background-size: auto 100%;
              }
            }
          }
        }
      }
    }



    .newly2 {
      display: inline-block;
      width: 160px;
      height: 90px;
      vertical-align: text-top;
      border: 1px dashed #D7D7D7;
      border-radius: 5px;
      margin-right: 20px;
      position: relative;
    }
    .newly2 span {
      display: block;
      width: 100%;
      color: #999999;
      margin: 0;
      padding: 0;
      text-align: center;
    }
    .newly2 span:first-child {
      font-size: 36px;
      line-height: 50px;
      position: absolute;
      top: 15px;
    }
    .newly2 span:last-child {
      font-size: 14px;
      line-height: 30px;
      position: absolute;
      bottom: 0;
    }
    .upload2 {
      display: inline-block;
      width: 160px;
      height: 90px;
      vertical-align: text-top;
      background-size: 100% 100%;
      position: relative;
    }

    .upload2 img {
      width: 100%;
      height: 100%;
      border-radius: 5px;
    }
    .upload2 b {
      display: inline-block;
      width: 100%;
      line-height: 21px;
      color: white;
      border-radius: 5px;
      background-color: #989796;
      text-align: center;
      position: absolute;
      bottom: 0;
      left: 0;
      opacity: .7;
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/IntellectualBrain/InterfaceConfig/InterfaceConfig.vue